import { render } from "./Banner.vue?vue&type=template&id=48e3ad5e&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=ts"
export * from "./Banner.vue?vue&type=script&lang=ts"

import "./Banner.vue?vue&type=style&index=0&id=48e3ad5e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48e3ad5e"

export default script